import React from "react";
import { submitMedikreditClaim } from "../../mediKreditapi";
import { buildClaimDiscounts } from "../../utils/claimDiscounts";

function formatDateYYYYMMDD(dateStr) {
  if (!dateStr) return "";
  return dateStr.replace(/-/g, "");
}

export async function ReverseClaim({ practice, account, selectedPatient, invoice, claimtxn }) {
  const practitioner = {
    hpcsa: invoice.practitioner.hpcsa,
  };

  const practiceInfo = {
    sp_bhf: practice.practiceNumber, //"0387495",
    sp_hpc: invoice.practitioner.hpcsa,
    grp_prac: practice.practiceNumber, //"0387495",
    tx_nbr: claimtxn,
    msg_fmt: "16",
    tx_cd: "11"
  };

  const medicalAidInfo = {
    plan: account.accountMediKreditPlanNumber03, // fallback or use account.accountMedicalAidPlanCode
    ch_id: account.accountMedicalAidNumber,
    sname: account.accountLastName,
    inits: account.accountInitials,
  };

  const patientInfo = {
    dep_cd: selectedPatient.patientMedicalAidDependantCode,
    dob: formatDateYYYYMMDD(selectedPatient.patientDOB),
    id_nbr: selectedPatient.patientIdNumber,
    fname: selectedPatient.patientFirstName,
    gend: selectedPatient.patientGender,
    rlnship: selectedPatient.patientRelationship,
    status: invoice.outPatient,
    int: selectedPatient.patientInitials
  };

  const caseInfo = {
    caseBHF: invoice.inPatientCase?.caseBHF,
    caseHPCSA: invoice.inPatientCase?.caseHPCSA,
    caseICD10: invoice.inPatientCase?.caseICD10,
  };

  // A discount is not a line here either — it rides on the item it reduces as
  // `sub_disc`, exactly as the original submission sent it, so the scheme can
  // match the reversal to the claim. Before this, a discount was reversed as
  // an ITEM of its own with a negative price and no tariff code.
  const invoiceLines = Array.isArray(invoice.lines) ? invoice.lines : [];
  const claimLines = invoiceLines.filter(
    (line) => line?.type !== "discount" && line.privatePayment !== true,
  );
  const rateOf = (line) => Number(line?.rate || 0);

  const { subDiscForLine, grossFromLines } = buildClaimDiscounts(
    invoiceLines,
    claimLines,
    rateOf,
  );

  // Derived from the items actually being reversed rather than read off the
  // invoice, which is net of discounts while the item prices are gross. No net
  // figure is sent: this line selection is not the invoice's medical-aid
  // split, so it is not what the backend would be reconciling against.
  const financialInfo = {
    totalMedAidAmount: grossFromLines,
  };

  // Build transaction info with modifier logic
  let currentLineNumber = 1;
  const transactionInfo = [];

  claimLines.forEach((line) => {
    const subDisc = subDiscForLine(line);
    // Base line
    const baseLine = {
      lin_num: currentLineNumber++,
      pay_adv: "P",
      tp: line.tariffCode ? "2" : "",
      cdg_set: "2",
      auth_nbr: "",
      descr: line.description,
      process_tp: "01",
      tar_cd: line.tariffCode,
      qty: "1",
      units: line.quantity,
      unit_tp: "06",
      st_dt: formatDateYYYYMMDD(line.appointmentDateSet || line.appointmentDateCustom),
      st_tm: "111213",
      end_dt: formatDateYYYYMMDD(line.appointmentDateSet || line.appointmentDateCustom),
      end_tm: "121213",
      stg_ind1: "01",
      cd1: line.icd101,
      stg_ind2: "02",
      cd2: line.icd102,
      tp_ind: "01",
      bhf_nbr: practice.practiceNumber,
      hpc_nbr: invoice.practitioner.hpcsa,
      tar_ind: "03",
      price: line.rate,
      bs_of_cst: "03",
      ...(subDisc > 0 ? { sub_disc: subDisc } : {}),
      gross: line.rate,
      sp_hpc: invoice.practitioner.hpcsa,
    };

    transactionInfo.push(baseLine);

    // Handle modifiers - support both array and single modifier for backward compatibility
    let modifiers = [];
    if (line.modifier) {
      if (Array.isArray(line.modifier)) {
        modifiers = line.modifier.filter(Boolean); // Remove any null/undefined values
      } else {
        modifiers = [line.modifier]; // Convert single modifier to array
      }
    }

    // Create a separate modifier line for each modifier
    modifiers.forEach((modifier) => {
      const modifiedLine = {
        lin_num: currentLineNumber++,
        pay_adv: "P",
        tp: "3", // Set to "3" for modifier lines
        cdg_set: "2",
        auth_nbr: "",
        descr: line.description,
        process_tp: "01",
        tar_cd: line.tariffCode,
        qty: "1",
        units: line.quantity,
        unit_tp: "06",
        st_dt: formatDateYYYYMMDD(line.appointmentDateSet || line.appointmentDateCustom),
        st_tm: "111213",
        end_dt: formatDateYYYYMMDD(line.appointmentDateSet || line.appointmentDateCustom),
        end_tm: "121213",
        stg_ind1: "01",
        cd1: line.icd101,
        stg_ind2: "02",
        cd2: line.icd102,
        tp_ind: "01",
        bhf_nbr: practice.practiceNumber,
        hpc_nbr: invoice.practitioner.hpcsa,
        tar_ind: "03",
        price: "0", // Set to "0" for modifier lines
        bs_of_cst: "03",
        gross: "0", // Set to "0" for modifier lines
        modtp: "3",
        mod: modifier,
        sp_hpc: invoice.practitioner.hpcsa,
      };

      transactionInfo.push(modifiedLine);
    });
  });

  console.log("transactionInfo", transactionInfo);
  try {
    const response = await submitMedikreditClaim(
      practiceInfo,
      medicalAidInfo,
      patientInfo,
      transactionInfo,
      financialInfo,
      caseInfo,
      undefined,
      selectedPatient?.patientMediKreditPlanNumber04,
    );
    
    console.log("✅ Claim Response:", response);
    return response;
  } catch (error) {
    console.error("❌ Claim Submission Failed:", error);
    throw error;
  }
}